<template>
  <div>
    <div style="padding: 20px">
      <el-form size="small">
        <el-row >
          <el-col :span="6">
             <el-form-item label="文章类型："   label-width="120px" >
                <el-select
                    v-model="queryParams.category"
                    style="height: 0.5rem;;width: 100%">
                  <el-option
                      v-for="dict in unitType"
                      :key="dict.value"
                      :label="dict.label"
                      :value="dict.value"
                  >
                  </el-option>
                </el-select>
             </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="文章标题：" label-width="120px">
              <el-input v-model="queryParams.title" type="text">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="text-align: center">
            <el-button @click="search" type="primary" icon="el-icon-search" size="mini">搜 索</el-button>
            <el-button @click="clearQuery()" icon="el-icon-refresh" size="mini">清 空</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="add">
        新增
      </el-button>
    </div>
    <div>
      <el-table
          :data="tableData"
          style="width: 100%;">
<!--        <el-table-column-->
<!--            prop="id"-->
<!--            align="center"-->
<!--            label="id"-->
<!--            width="240px">-->
<!--        </el-table-column>-->
        <el-table-column
            prop="title"
            align="center"
            label="文章标题"
            width="460px">
        </el-table-column>
        <el-table-column
            prop="author"
            align="center"
            label="作者"
            width="180px">
        </el-table-column>
        <el-table-column
            prop="category"
            align="center"
            label="文章类型"
            width="180px">
          <template slot-scope="{row}">
            <span v-for="item in unitType"
                  :key="item.value"
                  v-show="item.value==row.category">
              {{item.label}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
            prop="publishDate"
            align="center"
            label="发布日期"
            width="200px">
        </el-table-column>
        <el-table-column
            prop="status"
            align="center"
            label="是否展示"
            width="180px">
          <template slot-scope="{row}">
            {{row.showFlag!==1?'是':'否'}}
          </template>
        </el-table-column>
        <el-table-column
            prop="sortOrder"
            align="center"
            label="排序等级"
            width="180px"
        >
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="240px"
            class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
            >修改</el-button>
            <el-button
                size="mini"
                type="text"
                icon="el-icon-edit"
                @click="handleDel(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          style="text-align: center"
          layout="prev, pager, next"
          :total="total"
          :current-page="queryParams.pageNum"
          :page-size="queryParams.pageSize"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="open" width="60%">
      <el-form ref="form" :model="article">
      <el-row>
        <el-col :span="8">
          <el-form-item prop="title" label="文章标题:" label-width="120px">
            <el-input v-model="article.title" type="text">
            </el-input>
          </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item prop="author" label="作者：" label-width="120px">
              <el-input v-model="article.author" type="text" >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="category" label="文章类型：" label-width="120px">
              <el-select
                  v-model="article.category"
              style="width: 100%">
                <el-option
                    v-for="dict in unitType"
                    :key="dict.value"
                    :label="dict.label"
                    :value="dict.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="8">
            <el-form-item prop="summary" label="内容概述：" label-width="120px">
              <el-input v-model="article.summary" type="text">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="status" label="状态：" label-width="120px">
              <el-switch
                  v-model="article.status"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="sortOrder" label="排序等级：" label-width="120px">
              <el-input v-model="article.sortOrder" type="number" >
              </el-input>
            </el-form-item>
          </el-col>
      </el-row>
        </el-form>

      <div>
        <el-row>
          <el-col :span="12">
            <el-upload
                class="upload-demo"
                :action="fileUrl"
                :on-success="handleChange"
                :before-remove="beforeRemove"
                :on-remove="handleRemove"
                :headers="uploadHeaders"
                :file-list="article.attachments">
              <el-button size="small" type="primary">上传附件</el-button>
              <!--        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </el-upload>
          </el-col>
          <el-col :span="6">
            <el-upload
                style="border: #bfbfbf 1px solid;width: 210px;height: 200px"
                class="avatar-uploader"
                :show-file-list="false"
                :headers="uploadHeaders"
                :action="fileUrl"
                :on-success="handleAvatarSuccess">
              <img v-if="article.coverImage" :src="article.coverImage" class="avatar">
              <div v-else class="avatar-uploader-icon">上传封面</div>
              <!--        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
            </el-upload>
          </el-col>
        </el-row>
      </div>

      <wang-eidtor ref="editor" :value="article.content"></wang-eidtor>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" >提 交</el-button>
        <el-button @click="cancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {Message} from "element-ui";
import wangEidtor from "@/components/wangEditor"
import {addArticle, delArticle, getArticleList, updataArticle,getArticle} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {wangEidtor},
  data(){
    return {
      uploadHeaders: {
        Authorization: sessionStorage.getItem('token')// 假设token存储在Vuex中
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        category:undefined,
        title:undefined,

      },
      coverImage:[],
      total:0,
      tableData:undefined,
      open:false,
      title:undefined,
      unitType:[
        {value:1,
          label:'新闻资讯'},
        {value:2,
          label:'发展历程'},
        {value:3,
          label:'企业文化'},
        {value:4,
          label:'信息公示'},
        {value:5,
          label:'结果公示'},
        {value:6,
          label:'党建活动'},
        {value:7,
          label:'服务领域'},
        {value:8,
          label:'招聘公告'}
      ],
      fileUrl: process.env.VUE_APP_BASE_API+ "/file/upload",
      fileList:[],
      article:{
        id:undefined,
        title:undefined,
        content:undefined,
        author:undefined,
        publishDate:undefined,
        category:undefined,//	分类:文章类型 1.新闻资讯 2.发展历程 3.企业文化 4.招标公示 5.党建活动
        summary:undefined,
        coverImage:undefined,
        offlineDate:undefined,
        sortOrder:undefined,
        status:true,
        attachments:[],
        haveImage:false,//	是否有图片:		false
        haveVideo:false,//
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods:{
    clearQuery(){
          this.queryParams.category=undefined,
          this.queryParams.title=undefined
      this.getList()
    },
    handleAvatarSuccess(res) {
      if(res.code==403){
        Message.error('登录过期，请重新登录')
        setTimeout(() => {
          location.href = '/admin/login';
        })
      }
      this.article.coverImage = res.data;

    },
    handleRemove(file, fileList) {
      console.log(file,fileList)
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleChange(response,file, fileList) {
      if(response.code==403){
        Message.error('登录过期，请重新登录')
        setTimeout(() => {
          location.href = '/admin/login';
        })
      }
      fileList[fileList.length-1].fileUrl=response.data
      // fileList[fileList.length-1].fileName=file.fileName
      this.article.attachments=fileList
      // this.fileList = fileList.slice(-3);
    },
    handleDel(row){
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delData(row.id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      this.getList()
    },
    getArticle(id){
      getArticle(id).then((res)=>{
        let data=res.data
        this.article=data
        this.$nextTick(()=>{
          this.$refs.editor.html=this.article.content
        })
        for (let i = 0; i < this.article.attachments.length; i++) {
          this.article.attachments[i].name=this.article.attachments[i].fileName
        }
      })
    },
    delData(id){
      delArticle([id]).then(()=>{
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
        this.getList()
      })
    },
     handleUpdate(row){
      this.article= {}
      this.open=true
      this.title='修改文章'
       this.getArticle({id:row.id})
    },
    handleCurrentChange(pageNum){
      this.queryParams.pageNum=pageNum
      this.getList()
    },
    search(){
      this.queryParams.pageNum=1
      this.getList()
    },
    getList(){
      getArticleList(this.queryParams).then(async res=>{
        const data=await  res.data
        this.tableData= data.content
        this.total=data.totalElements
      })
    },
    clear(){
      this.article={
        id:undefined,
        title:undefined,
        content:undefined,
        author:undefined,
        publishDate:undefined,
        category:undefined,//	分类:文章类型 1.新闻资讯 2.发展历程 3.企业文化 4.招标公示 5.党建活动
        summary:undefined,
        coverImage:undefined,
        offlineDate:undefined,
        sortOrder:undefined,
        status:true,
        attachments:undefined,
      }
      this.$nextTick(()=>{
        this.$refs.editor.html=undefined
      })
    },
    add(){
      this.clear()
      this.open=true
      this.title="新增文章"
    },
    submitForm(){
      let iv= this.$refs.editor.haveImageorVideo()
      this.article.haveVideo=iv.video
      this.article.haveImage=iv.image
      this.article.content=this.$refs.editor.html
      if(this.article.attachments){
        for (let i = 0; i <this.article.attachments.length ; i++) {
          this.article.attachments[i].fileName=this.article.attachments[i].name
        }
      }
      if(this.title=='新增文章'){
        addArticle(this.article).then((res)=>{
          if(res.code==200){
            Message.success("新增成功")
            this.open=false
            this.getList()
          }else Message.error(res.msg)
        })
      }else {
        updataArticle(this.article).then((res)=>{
          if(res.code==200){
            Message.success("修改成功")
            this.open=false
            this.getList()
          }else {
            Message.error(res.msg)
          }
        })
      }
    },
    cancel(){
      this.open=false
    }
  }
}
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
